// extracted by mini-css-extract-plugin
export default {"removeBatchesButton":"RemoveSuperBatchesButton_removeBatchesButton__B94E6"};